module.exports = __webpack_public_path__ + "static/media/andrew-teasor.404e5328.jpg";